import { render, staticRenderFns } from "./ServiceObjectMaintenanceNotes.vue?vue&type=template&id=c4b4305a&"
import script from "./ServiceObjectMaintenanceNotes.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMaintenanceNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports